import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };

export default function Privacidad() {
  const navigate = useNavigate();
  const { isMobile } = useScreen();
  const s = { fontSize:14, color:'rgba(255,255,255,0.65)', lineHeight:1.8, margin:'0 0 16px' };
  const h = { fontFamily:serif, fontSize:18, fontWeight:400, color:'#fff', margin:'28px 0 10px' };
  const li = { ...s, margin:'0 0 6px' };

  return (
    <div style={{ minHeight:'100vh', background:'#0a0a0a', color:'#fff', fontFamily:font }}>
      <nav style={{ maxWidth:720, margin:'0 auto', padding:isMobile?'1rem':'1.2rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}>
          <div style={{ width:32, height:32, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}><span style={{ color:'#fff', fontSize:10, fontWeight:600 }}>T&D</span></div>
          <span style={{ fontSize:14, fontWeight:500 }}>Thinker & Doer</span>
        </div>
        <span onClick={() => navigate('/')} style={{ fontSize:13, color:'rgba(255,255,255,0.5)', cursor:'pointer' }}>← Inicio</span>
      </nav>

      <main style={{ maxWidth:720, margin:'0 auto', padding:isMobile?'2rem 1rem 4rem':'3rem 1.5rem 5rem' }}>
        <h1 style={{ fontFamily:serif, fontSize:isMobile?24:32, fontWeight:400, margin:'0 0 8px' }}>Aviso de Privacidad</h1>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.3)', margin:'0 0 32px' }}>Última actualización: julio 2026</p>

        <div style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:20, padding:isMobile?'24px 20px':'32px 28px' }}>
          <p style={s}><strong style={{color:'#fff'}}>Responsable:</strong> Thinker & Doer (T&D), México. Contacto: <strong style={{color:'#fff'}}>thinkanddo.er@gmail.com</strong></p>

          <h2 style={h}>Qué datos recolectamos</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}>Nombre y correo (vía tu cuenta de Google al iniciar sesión)</li>
            <li style={li}>Foto de perfil y datos que completes en tu perfil (intereses, industria, ciudad, identidad Thinker/Doer)</li>
            <li style={li}>El contenido que creas en la plataforma (ideas, pensamientos, mensajes)</li>
            <li style={li}>Datos de pago: los procesa Stripe directamente; nosotros no vemos ni guardamos tu tarjeta</li>
          </ul>

          <h2 style={h}>Para qué los usamos</h2>
          <ul style={{ ...s, paddingLeft:20 }}>
            <li style={li}>Darte acceso a tu cuenta y membresía</li>
            <li style={li}>Conectarte con otros emprendedores (matches) usando tus intereses y perfil</li>
            <li style={li}>Mostrar tu contenido público en la comunidad</li>
            <li style={li}>Procesar pagos y enviarte avisos del servicio</li>
            <li style={li}>Mejorar la plataforma</li>
          </ul>

          <h2 style={h}>Con quién los compartimos</h2>
          <p style={s}>Solo con los proveedores que hacen funcionar T&D: Google (inicio de sesión), Supabase (base de datos), Stripe (pagos) y Vercel (hosting). <strong style={{color:'#fff'}}>No vendemos tus datos a nadie.</strong></p>

          <h2 style={h}>Tus derechos (ARCO)</h2>
          <p style={s}>Puedes solicitar acceso, rectificación, cancelación u oposición sobre tus datos escribiendo a <strong style={{color:'#fff'}}>thinkanddo.er@gmail.com</strong>. También puedes borrar tus notas en cualquier momento desde la plataforma o pedirnos eliminar tu cuenta completa.</p>

          <h2 style={h}>Cambios a este aviso</h2>
          <p style={s}>Cualquier cambio se publicará en esta página.</p>
        </div>
      </main>
    </div>
  );
}
